const GUEST_MODE_KEY = "myStudioGuestMode";

export function isGuestMode() {
  return localStorage.getItem(GUEST_MODE_KEY) === "true";
}

export function enableGuestMode() {
  localStorage.removeItem("userToken");
  localStorage.removeItem("jwt");
  localStorage.setItem(GUEST_MODE_KEY, "true");
  localStorage.setItem("userEmail", "ospite@mystudio.local");
  localStorage.setItem("firstName", "Ospite");
  localStorage.setItem("lastName", "");
  localStorage.setItem("isAdmin", "false");
  localStorage.setItem("isAdminMyStudio", "false");
  localStorage.setItem(
    "user",
    JSON.stringify({
      email: "ospite@mystudio.local",
      first_name: "Ospite",
      last_name: "",
      is_admin: false,
      is_admin_MyStudio: false,
      is_guest: true,
      studio: {
        nome: "Modalità ospite",
        piano: "base",
      },
    })
  );
}

export function disableGuestMode() {
  localStorage.removeItem(GUEST_MODE_KEY);
}

export function clearGuestSession() {
  disableGuestMode();
  localStorage.removeItem("user");
  localStorage.removeItem("userEmail");
  localStorage.removeItem("firstName");
  localStorage.removeItem("lastName");
  localStorage.removeItem("isAdmin");
  localStorage.removeItem("isAdminMyStudio");
}
